import http from '@/helpers/Http';

export default {
    namespaced: true,
    state: {
        items: {
            data: [],
            links: {},
            meta: {},
        },
        selected: {},
    },
    getters: {
        items: state => state.items,
        selected: state => state.selected,
    },
    mutations: {
        setItems(state, items) {
            state.items = items;
        },
        setSelected(state, selected) {
            state.selected = selected;
        }
    },
    actions: {
        async index({ commit, rootState }) {
            const response = await http.get('sip/cdr', {
                params: rootState.route.query
            });

            commit('setItems', response.data);

            return response;
        },
    }
}